import log from 'loglevel';

import { createApiWithAuth } from '../utils/axios';

let userSessionApi: ReturnType<typeof createApiWithAuth> | null = null;

const getUserSessionApi = () => {
  if (!userSessionApi) {
    const baseUrl = import.meta.env.VITE_USER_SESSION_BASE_URL;
    if (!baseUrl) {
      throw new Error('User Session base URL is not set');
    }
    userSessionApi = createApiWithAuth(baseUrl);
  }
  return userSessionApi;
};

const handleRequestError = (context: string, error: unknown) => {
  log.error(`User Session API Error [${context}]:`, error);
  throw error;
};

export const createSession = async () => {
  try {
    const { data } = await getUserSessionApi().post('/sessions');
    return data;
  } catch (error) {
    handleRequestError('creating session', error);
  }
};
